import { render, staticRenderFns } from "./HeaderCart.vue?vue&type=template&id=bc956166&scoped=true&"
import script from "./HeaderCart.vue?vue&type=script&lang=js&"
export * from "./HeaderCart.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCart.vue?vue&type=style&index=0&id=bc956166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc956166",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VIcon})
